/**
 * Coid 2.0 server
 * Coid 2.0 server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OrganizationTypeSpecificTariff {
    NATIONAL_BANK = 'NATIONAL_BANK',
    NATIONAL_BANK_SUBSIDIARY_ORGANIZATION = 'NATIONAL_BANK_SUBSIDIARY_ORGANIZATION',
    NATIONAL_BANK_UL = 'NATIONAL_BANK_UL',
    NATIONAL_BANK_NON_COMMERCIAL_ORGANIZATION = 'NATIONAL_BANK_NON_COMMERCIAL_ORGANIZATION',
    GOVERNMENT_AGENCY = 'GOVERNMENT_AGENCY'
}

